/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/components/text-panel',['require','core/templates','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var templates = require('core/templates');
  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var TextPanel = Marionette.ItemView.extend({

  /////////////////
  // PROPERTIES //{
  /////////////////

    template: templates['modules/components/text-panel'],
    className: 'text-panel',
    events: {
      'click .close': 'closePressed'
    },

  /*****************************************************************************************************************///}

  //////////////
  // METHODS //{
  //////////////

    initialize: function(options)
    {
      if (!this.model.has('dismissable'))
        this.model.set('dismissable', true, { silent: true });

      if (!this.model.has('title'))
        this.model.set('title', null, { silent: true });

      if (!this.model.has('graphic'))
        this.model.set('graphic', null, { silent: true });

      if (!this.model.has('layout'))
        this.model.set('layout', '', { silent: true });
    },

    closePressed: function()
    {
      this.destroy();
    }

  /*****************************************************************************************************************///}

  });

  return TextPanel;

});

